import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import BsModal from "../../Misc/BsModal";
import SuperSelect from "../../Misc/SuperSelect";

export default class TrackerAdd extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      item: {},
    };
  }

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };

  save = async () => {
    const { item } = this.state;
    const { type } = this.props;

    this.setState({ pending: true });

    let result = await this.context.api.q("/tracker/set", {
      type: this.context.getType(type),
      ship: item.ship,
      departure: item.departure,
      arrival: type === "cruise.tracker" ? item.arrival : item.departure,
      label: item.label,
    });
    this.setState({ pending: false });
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");
      if (this.props.onAfterSave) {
        this.props.onAfterSave(item);
      }
      let urlKey = type.split(".").shift();

      this.props.onFinish({ mode: urlKey, id: result.id });
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
    }
  };
  render() {
    const { type } = this.props;
    const { item, pending } = this.state;
    return (
      <BsModal {...this.props}>
        <Blocker on={pending}>
          <h5>Добавить</h5>
          <hr />

          {/*<div className="form-group">
            <label>Название:</label>
            <input
              id="label"
              value={item.label || ""}
              onChange={(e) => this.onChange("label", e.target.value)}
              type="text"
              className="form-control"
            />
    </div>*/}

          <div className="form-group">
            <label>Судно:</label>
            <SuperSelect
              add
              defaultValue={item.ship}
              onChange={(value) => this.onChange("ship", value)}
              onSingleItem={(item) => this.onChange("ship", item.value)}
              essence="ship"
              placeholder="Выберите cудно..."
              nameField="name"
              idField="id"
            />
          </div>
          <div className="form-group">
            {type === "cruise.tracker" ? (
              <label>Порт отправления:</label>
            ) : (
              <label>Порт:</label>
            )}
            <SuperSelect
              add
              isClearable
              defaultValue={item.departure}
              onChange={(value) => this.onChange("departure", value)}
              essence="harbor"
              placeholder="Выберите порт..."
              nameField="name"
              idField="id"
            />
          </div>
          {type === "cruise.tracker" && (
            <div className="form-group">
              <label>Порт прибытия:</label>
              <SuperSelect
                add
                isClearable
                defaultValue={item.arrival}
                onChange={(value) => this.onChange("arrival", value)}
                essence="harbor"
                placeholder="Выберите порт..."
                nameField="name"
                idField="id"
              />
            </div>
          )}
          <hr />
          <button onClick={this.save} className="btn btn-primary mr-2">
            Добавить
          </button>
          <button className="btn btn-light" onClick={this.props.onClose}>
            Отмена
          </button>
        </Blocker>
      </BsModal>
    );
  }
}
